export const MAX_PLAYERS = 4;
export const AUTO_MATCH_PLAYERS = 2;
export const MIN_PLAYERS_TO_START = 2;
export const AUTO_MATCH_COUNTDOWN_MS = 10000;
export const AUTO_MATCH_TICKET_TTL_MS = 90000;
export const AUTO_MATCH_POLL_AFTER_MS = 1000;
export const TICK_RATE = 20;
export const SIMULATION_STEP_MS = 1000 / TICK_RATE;
export const MATCH_DURATION_MS = 5 * 60 * 1000;
export const SCORE_LIMIT = 10;
export const RESPAWN_MS = 3000;
export const SPAWN_PROTECTION_MS = 3000;

export const WORLD_BOUNDS_XZ = 100;
export const SURFACE_Y = -2;
export const SEABED_Y = -80;

export const PLAYER_MAX_HEALTH = 100;
export const PLAYER_RADIUS = 2;
export const PLAYER_MAX_SPEED = 5;
export const PLAYER_ACCELERATION = 8;
export const PLAYER_TURN_SPEED = 1.5;
export const PLAYER_VERTICAL_SPEED = 6;
export const PLAYER_FRICTION = 3;
export const PLAYER_VERTICAL_FRICTION = 2.5;
export const PLAYER_INITIAL_HOMING = 3;
export const PLAYER_INITIAL_MINES = 1;

export const REGULAR_TORPEDO_DAMAGE = 34;
export const REGULAR_TORPEDO_SPEED = 20;
export const REGULAR_TORPEDO_COOLDOWN_MS = 350;
export const REGULAR_TORPEDO_LIFESPAN_MS = 3000;

export const HOMING_TORPEDO_DAMAGE = 68;
export const HOMING_TORPEDO_SPEED = 15;
export const HOMING_TORPEDO_TURN_SPEED = 2;
export const HOMING_TORPEDO_COOLDOWN_MS = 0;
export const HOMING_TORPEDO_LIFESPAN_MS = 3000;

export const MINE_DAMAGE = 100;
export const MINE_RADIUS = 2;
export const MINE_COOLDOWN_MS = 0;
export const MINE_LIFESPAN_MS = 15000;

export const PROJECTILE_RADIUS = 0.3;
export const PICKUP_RADIUS = 1.2;
export const PICKUP_LIFESPAN_MS = 10000;
export const HEALTH_PICKUP_RESTORE_RATIO = 0.5;
export const HOMING_PICKUP_AMOUNT = 5;
export const MINE_PICKUP_AMOUNT = 3;
export const CHECKPOINT_INTERVAL_MS = 5000;
export const RECONNECT_GRACE_MS = 2 * 60 * 1000;
